import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    return; // DESABILITAR COMPLETAMENTE PARA PARAR O CONFLITO
    
    // Forçar padding-top: 0 na sidebar
    this.fixSidebarPadding()
    
    // Escutar eventos Turbo para reforçar a correção
    this.setupTurboListeners()
    
    // Configurar observador para mudanças na sidebar
    this.setupSidebarObserver()
    
    // Detectar se já há conteúdo carregado que precisa de navbar
    setTimeout(() => {
      this.detectAndCreateNavbar()
    }, 200)
  }

  setupMapMenuButton() {
    // Resetar observer anterior se existir
    if (this.mapButtonObserver) {
      this.mapButtonObserver.disconnect()
      this.mapButtonObserver = null
    }
    
    this.mapMenuButton = document.getElementById('map-menu-button')
    this.sidebar = document.getElementById('drawer-navigation')
    
    
    if (this.mapMenuButton && this.sidebar) {
      // Observer específico para o botão da ViewMap
      this.mapButtonObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.toggleMapMenuButton()
          }
        })
      })
      
      this.mapButtonObserver.observe(this.sidebar, { 
        attributes: true, 
        attributeFilter: ['class'] 
      })
      
      // Estado inicial
      this.toggleMapMenuButton()
    } else if (this.mapMenuButton) {
      // Se tem botão mas não tem sidebar, garantir que está visível
      this.showMapMenuButton()
    }
  }

  showMapMenuButton() {
    if (!this.mapMenuButton) return
    
    this.mapMenuButton.style.transition = 'all 0.3s ease-in-out'
    this.mapMenuButton.style.opacity = '1'
    this.mapMenuButton.style.visibility = 'visible'
    this.mapMenuButton.style.pointerEvents = 'auto'
  }

  toggleMapMenuButton() {
    if (!this.mapMenuButton || !this.sidebar) return
    
    const sidebarAberto = !this.sidebar.classList.contains('hidden')
    const isMapView = window.location.pathname.includes('/map')
    const hasNavbar = document.querySelector('nav') && 
                     document.querySelector('nav').style.display !== 'none'
    
    
    // Só esconde o botão se for MapView sem navbar e sidebar está aberto
    if (isMapView && !hasNavbar && sidebarAberto) {
      // Remove bruscamente - sem animação
      this.mapMenuButton.style.transition = 'none'
      this.mapMenuButton.style.opacity = '0'
      this.mapMenuButton.style.visibility = 'hidden'
      this.mapMenuButton.style.pointerEvents = 'none'
    } else {
      // Aparece com animação suave
      this.mapMenuButton.style.transition = 'all 0.3s ease-in-out'
      this.mapMenuButton.style.opacity = '1'
      this.mapMenuButton.style.visibility = 'visible'
      this.mapMenuButton.style.pointerEvents = 'auto'
    }
  }

  fixSidebarPadding() {
    const sidebar = document.getElementById('drawer-navigation')
    const main = document.querySelector('main')
    
    if (sidebar) {
      // Remover todas as classes e estilos relacionados
      sidebar.className = sidebar.className.replace(/pt-\d+/g, '').trim()
      sidebar.classList.remove('sidebar-with-navbar')
      
      // Limpar todos os estilos de posicionamento
      sidebar.style.removeProperty('padding-top')
      sidebar.style.removeProperty('margin-top')
      sidebar.style.removeProperty('transform')
      
      // VERIFICAR se deve ter navbar antes de forçar padding-top: 0
      const hasNavbar = this.shouldHaveNavbar()
      if (!hasNavbar) {
        // Só forçar padding-top: 0 se NÃO tem navbar (view do mapa)
        sidebar.style.setProperty('padding-top', '0px', 'important')
      } else {
      }
    }
    
    if (main) {
      // Remover todas as classes de padding-top existentes do main
      main.className = main.className.replace(/pt-\d+/g, '').trim()
      
      // Forçar padding-top: 0 via style
      main.style.setProperty('padding-top', '0px', 'important')
    }
    
    // Remover py-6 da div principal quando está na view do mapa
    this.removeMainPadding()
    
  }

  shouldHaveNavbar() {
    // Detectar se a view atual precisa de navbar (mesma lógica do dynamic-aside)
    const turboFrame = document.querySelector('turbo-frame[id="content-turbo-frame"]')
    
    if (turboFrame && turboFrame.innerHTML.trim().length > 0) {
      // Verificar se é conteúdo de mapa (sem navbar)
      const hasMapContent = turboFrame.querySelector('.map-container, .monitoring-dashboard, .vehicles-panel, [data-controller*="monitoring-map"], #monitoring-map-view, .leaflet-container')
      
      if (hasMapContent) {
        return false // É mapa, NÃO precisa de navbar
      }
      
      // Verificar se é conteúdo de aplicação (com navbar)
      const hasAppContent = turboFrame.querySelector('form, table, button, input, h1, h2, h3') || 
                           turboFrame.querySelectorAll('div').length > 5
      
      if (hasAppContent) {
        return true // É aplicação, PRECISA de navbar
      }
    }
    
    // Fallback: verificar URL
    const currentPath = window.location.pathname
    return !currentPath.includes('/monitoring/map') && !currentPath.includes('/monitoring/dashboard')
  }

  restoreSidebarPadding() {
    const sidebar = document.getElementById('drawer-navigation')
    
    if (sidebar) {
      // Limpar estilos anteriores
      sidebar.style.removeProperty('padding-top')
      sidebar.style.removeProperty('transform')
      sidebar.style.removeProperty('margin-top')
      
      // Remover todas as classes de padding-top existentes
      sidebar.className = sidebar.className.replace(/pt-\d+/g, '').trim()
      
      // Usar múltiplas abordagens para garantir que o sidebar seja empurrado para baixo
      sidebar.style.setProperty('padding-top', '20px', 'important')
      sidebar.style.setProperty('margin-top', '20px', 'important')
      sidebar.style.setProperty('transform', 'translateY(20px)', 'important')
      
      // Adicionar classe identificadora
      sidebar.classList.add('sidebar-with-navbar')
    }
    
    // Adicionar py-6 na div principal quando não está na view do mapa
    this.addMainPadding()
    
  }

  addMainPadding() {
    const mainDiv = document.querySelector('main > div.px-4')
    
    if (mainDiv && !mainDiv.classList.contains('py-6')) {
      // Remover py-* existentes
      mainDiv.className = mainDiv.className.replace(/py-\d+/g, '').trim()
      
      // Adicionar py-6
      mainDiv.classList.add('py-6')
    }
  }

  removeMainPadding() {
    const mainDiv = document.querySelector('main > div.px-4')
    
    if (mainDiv && mainDiv.classList.contains('py-6')) {
      // Remover py-* existentes
      mainDiv.className = mainDiv.className.replace(/py-\d+/g, '').trim()
    }
  }


  detectAndCreateNavbar() {
    const turboFrame = document.querySelector('turbo-frame[id="content-turbo-frame"]')
    
    if (!turboFrame) return
    
    // Detectar especificamente se É conteúdo do mapa (sinais únicos do mapa)
    const isMapContent = turboFrame.querySelector('.map-container, .monitoring-dashboard, .vehicles-panel, [data-controller*="monitoring-map"], #monitoring-map-view')
    const hasGoogleMapsScript = document.querySelector('script[src*="maps.googleapis.com"]')
    
    // Detectar se é conteúdo que precisa de navbar (características de layout application)
    const hasHeaderComponent = turboFrame.querySelector('.border-b.border-gray-200, .dark\\:border-gray-700')
    const hasApplicationBg = turboFrame.querySelector('.bg-white.dark\\:bg-gray-800')
    const hasElectronicFencesContent = turboFrame.querySelector('[class*="electronic"]')
    const hasFormContent = turboFrame.querySelector('form')
    const hasTable = turboFrame.querySelector('table')
    const hasCard = turboFrame.querySelector('.card, [class*="card"]')
    
    // Lógica: APENAS ativar navbar fake se:
    // 1. NÃO é conteúdo do mapa
    // 2. E TEM características de layout application
    if (!isMapContent && (hasHeaderComponent || hasApplicationBg || hasElectronicFencesContent || hasFormContent || hasTable || hasCard)) {
      // Adicionar classe para ativar CSS da navbar fake
      document.body.classList.add('needs-navbar-fake')
      // Restaurar padding-top 20px na sidebar quando não está na view do mapa
      this.restoreSidebarPadding()
    } else {
      // Remover classe da navbar fake
      document.body.classList.remove('needs-navbar-fake')
      // Garantir que remove padding quando é conteúdo do mapa
      this.fixSidebarPadding()
    }
  }

  setupTurboListeners() {
    // Eventos que podem afetar o layout
    const events = [
      'turbo:frame-load',
      'turbo:frame-render',
      'turbo:before-frame-render'
    ]

    events.forEach(eventName => {
      document.addEventListener(eventName, (event) => {
        // Verificar se é navegação que afeta layout monitoring
        if (event.target && (
          event.target.id === 'content-turbo-frame' ||
          event.target.querySelector('#content-turbo-frame')
        )) {
          // Aguardar múltiplos delays para garantir que o conteúdo foi carregado
          setTimeout(() => {
            this.detectAndCreateNavbar()
          }, 50)
          
          setTimeout(() => {
            this.detectAndCreateNavbar()
          }, 150)
          
          setTimeout(() => {
            this.detectAndCreateNavbar()
            
            // Se não precisar de navbar, aplicar padding zero
            if (!document.body.classList.contains('needs-navbar-fake')) {
              this.fixSidebarPadding()
            }
            
            // NOVO: Reconfigurar botão após navegação TurboFrame
            this.setupMapMenuButton()
          }, 300)
        }
      })
    })

    // Listener adicional específico para turboframe content-turbo-frame
    const contentFrame = document.querySelector('turbo-frame[id="content-turbo-frame"]')
    if (contentFrame) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            setTimeout(() => {
              this.detectAndCreateNavbar()
              // NOVO: Reconfigurar botão após mudança de conteúdo
              this.setupMapMenuButton()
            }, 100)
          }
        })
      })
      
      observer.observe(contentFrame, { childList: true, subtree: true })
      this.contentFrameObserver = observer
    }
  }

  hideContentDuringTransition() {
    const mainDiv = document.querySelector('main > div.px-4')
    const sidebar = document.getElementById('drawer-navigation')
    
    if (mainDiv) {
      mainDiv.style.opacity = '0'
      mainDiv.style.transition = 'opacity 0.1s'
    }
    
    if (sidebar) {
      sidebar.style.transition = 'none'
    }
  }

  applyLayoutWithoutFlicker() {
    // Detectar o tipo de conteúdo
    const turboFrame = document.querySelector('turbo-frame[id="content-turbo-frame"]')
    
    if (!turboFrame) return
    
    const isMapContent = turboFrame.querySelector('.map-container, .monitoring-dashboard, .vehicles-panel, [data-controller*="monitoring-map"], #monitoring-map-view')
    const hasHeaderComponent = turboFrame.querySelector('.border-b.border-gray-200, .dark\\:border-gray-700')
    const hasApplicationBg = turboFrame.querySelector('.bg-white.dark\\:bg-gray-800')
    const hasElectronicFencesContent = turboFrame.querySelector('[class*="electronic"]')
    const hasFormContent = turboFrame.querySelector('form')
    const hasTable = turboFrame.querySelector('table')  
    const hasCard = turboFrame.querySelector('.card, [class*="card"]')
    
    const needsNavbar = !isMapContent && (hasHeaderComponent || hasApplicationBg || hasElectronicFencesContent || hasFormContent || hasTable || hasCard)
    
    // Aplicar layout instantaneamente enquanto está escondido
    if (needsNavbar) {
      document.body.classList.add('needs-navbar-fake')
      this.restoreSidebarPadding()
    } else {
      document.body.classList.remove('needs-navbar-fake')
      this.fixSidebarPadding()
    }
    
    // Mostrar o conteúdo após aplicar o layout
    setTimeout(() => {
      const mainDiv = document.querySelector('main > div.px-4')
      if (mainDiv) {
        mainDiv.style.opacity = '1'
      }
    }, 50)
  }


  applyNavbarLayout() {
    // Aplicar tudo de uma vez para evitar pulos na tela
    document.body.classList.add('needs-navbar-fake')
    this.restoreSidebarPadding()
  }

  applyMapLayout() {
    // Aplicar tudo de uma vez para evitar pulos na tela
    document.body.classList.remove('needs-navbar-fake')
    this.fixSidebarPadding()
  }

  setupSidebarObserver() {
    // MutationObserver para detectar mudanças na sidebar
    if (this.sidebarObserver) {
      this.sidebarObserver.disconnect()
    }

    this.sidebarObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          
          const element = mutation.target
          if (element.id === 'drawer-navigation' || element.tagName === 'MAIN') {
            // Verificar se tem padding-top diferente de 0
            const computedStyle = window.getComputedStyle(element)
            const currentPaddingTop = computedStyle.paddingTop
            
            if (currentPaddingTop !== '0px') {
              this.fixSidebarPadding()
            }
          }
        }
      })
    })

    // Observar a sidebar e main se existirem
    const sidebar = document.getElementById('drawer-navigation')
    const main = document.querySelector('main')
    
    if (sidebar) {
      this.sidebarObserver.observe(sidebar, { 
        attributes: true, 
        attributeFilter: ['class', 'style'] 
      })
    }
    
    if (main) {
      this.sidebarObserver.observe(main, { 
        attributes: true, 
        attributeFilter: ['class', 'style'] 
      })
    }
  }

  disconnect() {
    // Limpar observers
    if (this.sidebarObserver) {
      this.sidebarObserver.disconnect()
      this.sidebarObserver = null
    }
    
    if (this.contentFrameObserver) {
      this.contentFrameObserver.disconnect()
      this.contentFrameObserver = null
    }
    
    if (this.mapButtonObserver) {
      this.mapButtonObserver.disconnect()
      this.mapButtonObserver = null
    }
  }
}